export default function csrfParam(): string {
  return $('meta[name=csrf-param]').attr('content');
}
